<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <el-button
        class="refresh-button"
        icon="el-icon-refresh"
        style="font-size: 18px"
        title="刷新"
        @click="refreshTable"
      />
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 20,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 15, 30, 50, 100, 200];
      },
    },
    layout: {
      type: String,
      default: "prev, pager, next,  jumper,  total, sizes, slot",
    },
    background: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
    },
    refreshTable() {
      this.$emit("pagination", {
        page: this.currentPage,
        limit: this.pageSize,
      });
    },
  },
};
</script>

<style type="text/css">
.el-pagination__editor.el-input .el-input__inner {
  line-height: 28px;
}

.v-modal {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000000;
}
</style>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 5px 5px;
  margin-top: 5px;
}
.pagination-container.hidden {
  display: none;
}
</style>

<style type="text/css">
.el-pagination__editor.el-input .el-input__inner {
  line-height: 28px;
}

.v-modal {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue